import { render } from "./BaseDashboardHeader.vue?vue&type=template&id=2aea30b4"
import script from "./BaseDashboardHeader.vue?vue&type=script&lang=js"
export * from "./BaseDashboardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/helpers/BaseDashboardHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2aea30b4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2aea30b4', __exports__)) {
    api.reload('2aea30b4', __exports__)
  }
  
  module.hot.accept("./BaseDashboardHeader.vue?vue&type=template&id=2aea30b4", () => {
    api.rerender('2aea30b4', render)
  })

}


export default __exports__